import React, { useRef } from 'react';
import { usePlotArea, useYAxisDomain } from 'recharts';
import { WEIGHT_STEP } from '../utils/loadProgression';

export default function LoadDragDot({ cx, cy, payload, stroke, step, onPreview, onCommit, onCancel, onBegin }) {
  const plot = usePlotArea();
  const domain = useYAxisDomain();
  const drag = useRef(null);
  if (!Number.isFinite(cx) || !Number.isFinite(cy)) return null;
  if (!step) return <circle cx={cx} cy={cy} r={3} fill={stroke} pointerEvents="none" />;
  const valueAt = event => {
    const state = drag.current;
    return Math.max(0, Math.min(state.maximum, state.weight + (state.y - event.clientY) * state.kgPerPixel));
  };
  return <g>
    <circle cx={cx} cy={cy} r={8} fill={stroke} stroke="white" strokeWidth={2} pointerEvents="none" />
    <circle cx={cx} cy={cy} r={22} fill="transparent" role="slider" tabIndex={0}
      aria-label={`Carga planificada ${step.date}`} aria-valuemin={0} aria-valuenow={payload.planned} aria-valuetext={`${payload.planned} kg`} aria-orientation="vertical"
      style={{ cursor: 'ns-resize', touchAction: 'none' }}
      onPointerDown={event => {
        if ((event.pointerType === 'mouse' && event.button !== 0) || drag.current || !plot?.height || !domain) return;
        const svg = event.currentTarget.ownerSVGElement;
        const rect = svg.getBoundingClientRect();
        if (!rect.height) return;
        event.preventDefault(); event.stopPropagation();
        const svgHeight = svg.viewBox?.baseVal?.height || Number(svg.getAttribute('height')) || 330;
        drag.current = { pointerId: event.pointerId, y: event.clientY, weight: payload.planned,
          maximum: Number(domain[1]), kgPerPixel: (Number(domain[1]) - Number(domain[0])) / plot.height * svgHeight / rect.height };
        event.currentTarget.setPointerCapture(event.pointerId);
        onBegin();
      }}
      onPointerMove={event => {
        if (!drag.current || drag.current.pointerId !== event.pointerId) return;
        event.preventDefault(); event.stopPropagation();
        onPreview(step.id, valueAt(event));
      }}
      onPointerUp={event => {
        if (!drag.current || drag.current.pointerId !== event.pointerId) return;
        const weight = valueAt(event);
        drag.current = null;
        event.preventDefault(); event.stopPropagation();
        onCommit(step.id, weight);
        if (event.currentTarget.hasPointerCapture(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId);
      }}
      onPointerCancel={() => { if (drag.current) { drag.current = null; onCancel(); } }}
      onLostPointerCapture={() => { if (drag.current) { drag.current = null; onCancel(); } }}
      onKeyDown={event => {
        if (event.key === 'Escape' && drag.current) { drag.current = null; onCancel(); }
        if (!['ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault(); event.stopPropagation();
        onCommit(step.id, payload.planned + (event.key === 'ArrowUp' ? WEIGHT_STEP : -WEIGHT_STEP));
      }} />
  </g>;
}
